export default __webpack_public_path__ + "static/media/var.aa6113f3.jpg";